import { makeStyles } from '@material-ui/core/styles';

const useFixedButtonStyles = makeStyles((theme) => {
	return {
		fixedButton: {
			position: 'relative',
			marginBottom: '3vh',
			marginLeft: '-1vh',
			[theme.breakpoints.up('md')]: {
				position: 'absolute',
				top: '5vh',
				left: '8vw',
			},
		},
	};
});

export default useFixedButtonStyles;
